import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useLanguage from "../../../hooks/useLanguage";

const GROUPS = [
  {
    group: "playback",
    rows: [
      { keys: ["Space"], label: "playPause" },
      { keys: ["Alt", "←"], altKeys: ["Alt", "→"], label: "frameStep" },
      { keys: ["Home"], label: "seekStart" },
      { keys: ["End"], label: "seekEnd" },
    ],
  },
  {
    group: "crop",
    rows: [
      { keys: ["←", "→", "↑", "↓"], label: "nudge" },
      { keys: ["Shift", "←", "→", "↑", "↓"], label: "nudgeFast" },
      { keys: ["Ctrl+C"], label: "copyCrop" },
      { keys: ["Ctrl+V"], label: "pasteCrop" },
    ],
  },
  {
    group: "scenes",
    rows: [
      { keys: ["Alt", "↑"], altKeys: ["Alt", "↓"], label: "prevNextScene" },
      { keys: ["S"], label: "split" },
      { keys: ["M"], label: "mergeNext" },
      { keys: ["Shift+M"], label: "mergePrev" },
      { keys: ["Esc"], label: "clearSelection" },
    ],
  },
  {
    group: "editing",
    rows: [
      { keys: ["Ctrl+Z"], label: "undo" },
      { keys: ["Ctrl+Shift+Z"], altKeys: ["Ctrl+Y"], label: "redo" },
      { keys: ["?"], label: "help" },
    ],
  },
];

const keyChip = {
  height: 20,
  fontSize: "0.68rem",
  fontFamily: "monospace",
  backgroundColor: "rgba(155,70,225,0.14)",
  color: "#c89bf2",
  border: "1px solid rgba(155,70,225,0.35)",
  "& .MuiChip-label": { px: 0.8 },
};

export default function ShortcutsDialog({ open, onClose }) {
  const [{ pages: { reframeEditor: text } }] = useLanguage();
  const t = text.shortcutsDialog;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t.title}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2.5, pb: 3 }}>
        {GROUPS.map(({ group, rows }) => (
          <Box key={group}>
            <Typography variant="overline" color="text.secondary">
              {t.groups[group]}
            </Typography>
            {rows.map(({ keys, altKeys, label }) => (
              <Box
                key={label}
                sx={{ display: "flex", alignItems: "center", gap: 1, py: 0.5 }}
              >
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, minWidth: 150 }}>
                  {keys.map((k) => <Chip key={k} label={k} size="small" sx={keyChip} />)}
                  {altKeys && <Typography variant="caption" color="text.secondary">/</Typography>}
                  {altKeys?.map((k) => <Chip key={`alt-${k}`} label={k} size="small" sx={keyChip} />)}
                </Box>
                <Typography variant="body2">{t[label]}</Typography>
              </Box>
            ))}
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
}
